// Helix colouring. A single continuous ramp cannot be both locally contrasty
// and globally unique. Hue rotates quickly (neighbouring strands differ) while
// lightness rises monotonically across the traversal, so no two positions on
// the curve ever share a colour.
import type { RGB } from '../types.ts';

export const HELIX = { Lmin: 28, Lmax: 92, C: 46 };

export function labToRgb(L: number, A: number, B: number): RGB {
  const fy = (L + 16) / 116, fx = fy + A / 500, fz = fy - B / 200;
  const inv = (f: number) => { const c = f * f * f; return c > 0.008856 ? c : (f - 16 / 116) / 7.787; };
  const X = inv(fx) * 0.95047, Y = inv(fy), Z = inv(fz) * 1.08883;
  const r = X * 3.2406 + Y * -1.5372 + Z * -0.4986;
  const g = X * -0.9689 + Y * 1.8758 + Z * 0.0415;
  const b = X * 0.0557 + Y * -0.2040 + Z * 1.0570;
  const enc = (v: number) => {
    v = v <= 0.0031308 ? 12.92 * v : 1.055 * Math.pow(Math.abs(v), 1 / 2.4) - 0.055;
    return Math.max(0, Math.min(255, Math.round(v * 255)));
  };
  return [enc(r), enc(g), enc(b)];
}

export function helixAt(t: number, turns: number): RGB {
  const u = Math.max(0, Math.min(1, t));
  const L = HELIX.Lmin + (HELIX.Lmax - HELIX.Lmin) * u;   // strictly monotone
  const h = 2 * Math.PI * turns * u;
  return labToRgb(L, HELIX.C * Math.cos(h), HELIX.C * Math.sin(h));
}
